module.exports = __webpack_public_path__ + "static/media/cafe-mamia.20c6220e.jpg";